"use strict";

module.exports = [
  "$scope",
  "$rootScope",
  "$http",
  "$sce",
  "$timeout",
  "$modalInstance",
  "config",
  "OrderSvc",
  "MaterialSvc",
  "PlantSvc",
  "ModalSvc",
  "PermissionSvc",
  "OrderRequestSvc",
  function(
    $scope,
    $rootScope,
    $http,
    $sce,
    $timeout,
    $modalInstance,
    config,
    OrderSvc,
    MaterialSvc,
    PlantSvc,
    ModalSvc,
    PermissionSvc,
    OrderRequestSvc
  ) {
    /* ####### Helper Functions ###### */

    function handleSuccess(data) {
      // fire an event and pass the updated order
      $rootScope.$broadcast("refresh-signal", data);

      // enable save buttons
      $scope.disableInput = false;

      $modalInstance.close();
    }

    function handleErrors(data) {
      $scope.error = data;
      $scope.disableInput = false;
      // close the notification
      if ($scope.notification){
          $scope.notification.close();
        }
    }

    function mapFormData(order) {
      let cleaned_data = {
        id: order.id,
        customer: order.customer,
        material: order.material,
        tentative: order.tentative,
        extra_fields_data: $scope.extra_fields_data,
        comment: order.comment,
        dates: order.dates,
        notify_team: order.notify_team,
      };

      if (angular.isDefined(order.order)) {
        cleaned_data.order = order.order;
      }

      return cleaned_data;
    }

    function moveOrderItems() {
      $scope.mode = "move";

      // save id for notification
      let oldId = $scope.order.id;

      $scope.order = angular.copy($scope.order);
      // remove id key from order
      if ($scope.order.id) {
        delete $scope.order.id;
      }

      let old_order_dates = angular.copy($scope.order.dates);
      $scope.order.dates = [];

      for (let order_date_id in old_order_dates) {
        if (old_order_dates[order_date_id].__selected) {
          $scope.order.dates.push(old_order_dates[order_date_id]);
        }
      }

      return oldId;
    }

    function orderToUpdateRequest() {
      // copies the order and removes ids to create an update request

      let order_id = $scope.order.id;

      let update_request = angular.copy($scope.order);
      update_request.order = order_id;

      // remove id key from order
      if (update_request.id) {
        delete update_request.id;
      }

      update_request.dates.forEach((date, index) => {
        date.order_date = date.id;
        delete date.id;
        delete date.order;
      });

      return update_request;
    }

    function copyOrder() {
      $scope.canEdit = true;

      // save id for notification
      let oldId = $scope.order.id;

      $scope.order = angular.copy($scope.order);

      // remove id key from order
      if ($scope.order.id) {
        delete $scope.order.id;
        delete $scope.order.status;
      }

      $scope.order.dates.forEach((date, index) => {
        delete date.id;
      });

      return oldId;
    }

    function showNotification(message, type) {
      $scope.notification = {
        message: $sce.trustAsHtml(message),
        type: type,
        close: function() {
          delete $scope.notification;
        }
      };
    }

    function sortDates(dates) {
      return dates.sort(function(item1, item2) {
        let item_1_delivery_on = moment(
          item1.delivery_on,
          $scope.$root.dateFormat.moment
        );
        let item_2_delivery_on = moment(
          item2.delivery_on,
          $scope.$root.dateFormat.moment
        );

        let result = 0;

        if (item_1_delivery_on.isAfter(item_2_delivery_on)) {
          result = 1;
        }

        if (item_1_delivery_on.isBefore(item_2_delivery_on)) {
          result = -1;
        }

        return result;
      });
    }

    function mapOrderFields(data) {
      let fields = [];

      if ($scope.typeIs("request")) {
        data = data.filter(function(item) {
          return item.visible_to_customer;
        });
      }

      // add order fields that are not yet there
      data.forEach(function(item, index) {
        let existing_item = Array.findObject(
          $scope.order.extra_fields_data,
          "key",
          item.name
        );

        let field_item;

        if (existing_item === -1) {
          field_item = {
            key: item.name,
            value: "",
            type: item.field_type
          };
        } else {
          field_item = existing_item;
        }

        field_item.visible_to_customer = item.visible_to_customer;

        fields.push(field_item);
      });

      $scope.extra_fields_data = fields;
    }

    function getDataService() {
      return $scope.type === "order" ? OrderSvc : OrderRequestSvc;
    }

    /* ####### END Helper Functions ###### */

    /* ####### Scope Functions ###### */

    $scope.typeIs = function(type) {
      return $scope.type === type;
    };

    $scope.hasSelectedItems = function() {
      // Hide the 'to new order' buttons for now

      /* for (let order in $scope.order.dates) {
        if ($scope.order.dates[order].__selected) {
          return true;
        }
      }
      */
      return false;
    };

    $scope.openDeleteDialog = function() {
      const config = {
        order_id: $scope.order.id,
        order_dates: $scope.order.dates
      };

      ModalSvc.orderDeleteModal.open(config);

      $modalInstance.close();
    };

    $scope.openRejectOrderRequestModal = function() {
      let modal = ModalSvc.orderRequestRejectModal.open({
        order_request: $scope.order,
        output_materials: $scope.output_materials
      });

      $scope.nestedModalOpened = true;

      modal.result.then(
        function(reason) {
          $scope.disableInput = true;
          $scope.error = {};
          OrderRequestSvc.reject($scope.order, $rootScope.plant, reason)
            .success(handleSuccess)
            .error(handleErrors);
        },
        function() {
          $scope.nestedModalOpened = false;
        }
      );
    };

    $scope.saveOrderClick = function() {
      $scope.dataSvc = getDataService();

      $scope.disableInput = true;
      $scope.error = {};

      let order = mapFormData(angular.copy($scope.order));

      if (
        $scope.role !== "Customer" &&
        $scope.mode === "edit" &&
        $scope.type === "request"
      ) {
        return $scope.dataSvc
          .approve(order, $rootScope.plant)
          .success(handleSuccess)
          .error(handleErrors);
      }

      if (
        $scope.mode === "create" ||
        $scope.mode === "copy" ||
        $scope.mode === "move"
      ) {
        // make a save request to server
        return $scope.dataSvc
          .create(order, $rootScope.plant)
          .success(handleSuccess)
          .error(handleErrors);
      }

      if ($scope.mode === "edit") {
        return $scope.dataSvc
          .update(order, $rootScope.plant)
          .success(handleSuccess)
          .error(handleErrors);
      }
    };

    $scope.moveOrderItemsClick = function($event) {
      const id = moveOrderItems();
      showNotification(
        `Moved orders from order #${id}. <br /> Please check the new delivery date and press 'Save changes' to continue.`,
        "warning"
      );

      // TEMPORARY HACK BEFORE WE FIX THE MODALS SCROLL TODO: Anton fix this
      $(".modal").scrollTop(0);
    };

    $scope.copyOrderClick = function($event) {
      $scope.mode = "copy";
      const id = copyOrder();

      if ($scope.type === "request") {
        showNotification(
          `We created a copy of order request #${id}. <br /> Please select the new delivery date and press 'Request' to continue.`,
          "warning"
        );
      }

      if ($scope.type === "order") {
        showNotification(
          `We created a copy of order #${id}. <br /> Please select the new delivery date and press 'Save changes' to continue.`,
          "warning"
        );
      }

      // TEMPORARY HACK BEFORE WE FIX THE MODALS SCROLL TODO: Anton fix this
      $(".modal").scrollTop(0);
    };

    $scope.requestOrderUpdate = function() {
      $scope.type = "request";
      $scope.mode = "create";
      $scope.canEdit = true;
      $scope.order = orderToUpdateRequest();

      // TEMPORARY HACK BEFORE WE FIX THE MODALS SCROLL TODO: Anton fix this
      $(".modal").scrollTop(0);
    };

    $scope.cancelClick = function() {
      $modalInstance.close();
    };

    $scope.openOrderDialog = function(config) {
      $scope.nestedModalOpened = true;

      const modal = ModalSvc.orderEditModal.open(config);

      modal.result.finally(function() {
        $scope.nestedModalOpened = false;
      });
    };

    /* ####### END Scope Functions ###### */

    /* ####### Initialization ###### */

    $scope.order = {
      extra_fields_data: []
    };

    $scope.plant_object = {
      id: $rootScope.plant,
      name: PermissionSvc.permissionCache_by_id[$rootScope.plant].plant_name
    };

    $scope.mode = config.order_id > 0 ? "edit" : "create"; // 'create, 'edit', 'copy'

    $scope.type = config.type || "order"; // "order", "request"

    $scope.dataSvc = getDataService();

    $scope.output_materials = [];

    $scope.visibleToCustomerTooltip = {
      title: "This field is visible by the customers."
    };

    function init() {
      $scope.close_only = config.close_only;

      if (angular.isDefined(config.can_edit)) {
        $scope.canEdit = config.can_edit;
      }

      if ($scope.role !== "Customer") {
        PlantSvc.getCustomers($rootScope.plant).success(function (data) {
          $scope.customers = data;
        });
      }

      // get order(if edit) and custom fields for order
      if (config.order_id > 0) {
        let method = "get";

        if ($scope.role === "Customer" && $scope.type === "order") {
          method = "get_customer_order";
        }

        $scope.dataSvc[method](config.order_id, $rootScope.plant).success(
          function(order) {
            PlantSvc.getOrderFields($rootScope.plant).success(mapOrderFields);

            if (config.approve) {
              // If the approve action was triggered, mark as approved.
              order.tentative = false;
            }

            $scope.order = order;

            if (order.status === "rejected") {
              $scope.canEdit = false;
            }

            // convert time to date for time picker
            order.dates = order.dates.map(orderDate => {
              if (orderDate.load_time) {
                orderDate.load_time = moment(orderDate.load_time).toDate();
              }
              return orderDate;
            });

            sortDates(order.dates);
          }
        );
      } else {
        PlantSvc.getOrderFields($rootScope.plant).success(mapOrderFields);
        let date = config.delivery_on ? moment(config.delivery_on, $scope.$root.dateFormat.moment)
          : moment();
        $scope.order.delivery_on = date.format($scope.$root.dateFormat.moment);
        $scope.order.dates = [
          {
            delivery_on: date.format($scope.$root.dateFormat.moment),
            nightshift: false,
            load_time: null
          }
        ];
        if ($scope.type === "request") {
          $scope.order.customer =
            PermissionSvc.permissionCache_by_id[$rootScope.plant].user_name;
        }
      }

      $timeout(function() {
        // noop, fixes bug with -webkit-overflow-scroll events.
        $(".modal")[0].addEventListener("touchstart", angular.noop);
      });
    }

    /* ####### END Initialization ###### */

    /* ####### Load Dependent Data ###### */

    PermissionSvc.getPlantPermissions($scope.plant).then(function(permissionsObject) {
      $scope.role = permissionsObject.role;
      $scope.permissions = permissionsObject.permissions;

      $scope.canEdit =
        ($scope.permissions.edit_orders && $scope.type === "order") ||
        ($scope.permissions.create_order_request && $scope.type === "request") ||
        ($scope.permissions.approve_order_request &&
          $scope.type === "request") ||
        ($scope.permissions.edit_order_request && $scope.type === "request");

      init();
    });

    MaterialSvc.list($rootScope.plant).success(function(data) {
      $scope.output_materials = data.filter(function(item) {
        return item.is_output_material;
      });
    });

    /* ####### END Load Dependent Data ###### */
  }
];
